import Grid from '@/global/components/ui/Grid'
import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { useParams } from 'react-router-dom'
import { AvaliacaoSchema, usuarios as usuarios_api } from 'service/api'
import { toast } from 'sonner'
import { z } from 'zod'

export default function AdminAlterarSenha() {
    const { id } = useParams()
    const { data: usuario } = usuarios_api.useFetchById(Number(id), {
        enabled: !!id,
    })
    const { mutateAsync } = usuarios_api.mutations.useUpdate({
        invalidateQuery: true,
        onError: e => {
            toast.error(e.message)
        },
        onSuccess: () => {
            toast.success('Senha alterada com sucesso')
        },
    })

    if (!usuario) return null

    return (
        <Dialog.Root
            height="auto"
            schema={z
                .object({
                    senha: AvaliacaoSchema.shape.senha,
                    repetirSenha: AvaliacaoSchema.shape.senha,
                })
                .refine(data => data.senha === data.repetirSenha, {
                    message: 'As senhas não coincidem',
                    path: ['repetirSenha'],
                })}
            onSubmit={v =>
                mutateAsync({
                    password: v.senha,
                    id: usuario.id,
                })
            }
        >
            <Dialog.Title>{usuario.email}</Dialog.Title>
            <Dialog.Content dividers>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormField
                            name="senha"
                            label="Nova senha"
                            type="password"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            name="repetirSenha"
                            label="Confirmar senha"
                            type="password"
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
